// Les guides, en sommaire : une ligne par guide, numérotée, comme la table
// des matières d'un carnet de terrain. Rôle SEO (l'accueil transmet son poids
// aux guides) et réponse à la question précise du visiteur indécis.
import { Link } from 'react-router-dom'
import GUIDES from '../../content/guides'
import { useT } from '../../lib/i18n'
import { Arrow } from './Icons'

export default function GuidesTeaser () {
  const t = useT().guidesTeaser
  const picks = t.slugs.map(s => GUIDES.find(g => g.slug === s)).filter(Boolean)

  return (
    <section className="lp-sec" id="guides">
      <div className="lp-wrap lp-gl">
        <div className="lp-gl__head lp-rv">
          <span className="lp-kicker">{t.kicker}</span>
          <h2 className="lp-h2">{t.title}</h2>
          <p className="lp-lead">{t.lead}</p>
          <Link to="/guides" className="lp-link lp-gl__all">{t.all} <Arrow /></Link>
        </div>

        <ol className="lp-gl__list">
          {picks.map((g, i) => (
            <li key={g.slug} className="lp-rv">
              <Link to={`/guides/${g.slug}`} className="lp-gl__row">
                <span className="lp-gl__n">{String(i + 1).padStart(2, '0')}</span>
                <span className="lp-gl__t">
                  {g.kicker && <small>{g.kicker}</small>}
                  {g.title}
                </span>
                <span className="lp-gl__m">{g.minutes ? `${g.minutes} min` : ''}</span>
                <span className="lp-gl__go"><Arrow /></span>
              </Link>
            </li>
          ))}
        </ol>
      </div>
    </section>
  )
}
